import React, { FC, useContext } from 'react';
import get from 'lodash/get';
import produce from 'immer';
import set from 'lodash/set';
import styled from 'styled-components';

import BusinessHoursExceptionItem from './BusinessHoursExceptionItem';
import FormContext from 'src/presentation/contexts/FormContext';
import Header, { StyledDescription } from '../Header';
import {
  EditorSection,
  ErrorContainer,
  ItemActions,
  OptionTable,
  StyledOptionsSection,
  StyledSectionContainer,
} from 'src/presentation/components/pages/shared/EditorSectionLayout';

type BusinessHoursExceptionsProps = {
  attr?: string;
  dataAid?: string;
  errors: any;
};

const BusinessHoursExceptions: FC<BusinessHoursExceptionsProps> = ({
  errors,
  attr = 'officeHours.exceptions',
  dataAid = 'officeHours-exceptions',
}) => {
  const { workingState, updateState } = useContext(FormContext);

  const getNewItemDefaultData = () => ({
    name: '',
    start: '',
    stop: '',
    closed: false,
  });

  const renderItem = ({ index }) => {
    return (
      <BusinessHoursExceptionItem
        attr={`${attr}[${index}]`}
        baseAttr={attr}
        data-aid={`${dataAid}[${index}]`}
        index={index}
        key={index}
      />
    );
  };

  const deleteHandler = (_, index) => {
    const exceptions = produce(get(workingState, attr, []), draft => {
      draft.splice(index, 1);
    });

    updateState(set({}, attr, exceptions), { replaceArrayValues: true });
  };

  return (
    <SectionEditorContainer>
      <Header headerText="Exceptions" />
      <StyledDescription>Set the days and time range when your business will be closed or extended.</StyledDescription>
      <StyledEditorSection
        addButtonLabel="Add exception"
        attr={attr}
        errors={errors}
        data-aid={dataAid}
        getNewItemDefaultData={getNewItemDefaultData}
        title=""
        renderItem={renderItem}
        prefixWord={() => ''}
        onDelete={deleteHandler}
      />
    </SectionEditorContainer>
  );
};

const SectionEditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledEditorSection = styled(EditorSection)`
  width: 100%;

  ${StyledOptionsSection} {
    padding-top: 0;
  }

  ${OptionTable} {
    margin: 0;
  }

  ${StyledSectionContainer} {
    margin-top: 16px;
  }

  ${ErrorContainer} {
    display: none;
  }

  ${ItemActions} {
    width: 32px;
  }
`;

export default BusinessHoursExceptions;
